/**
 * Arabic Legal Translations
 * 法律文档翻译模块 - 阿拉伯语
 * 
 * 包含隐私政策 (privacy) 和服务条款 (terms) 等法律文档的翻译
 */

import type { LegalTranslations } from '../../types';

export const arLegal: LegalTranslations = {
  privacy: {
    title: 'سياسة الخصوصية',
    subtitle: 'كيف نجمع معلوماتك الشخصية ونستخدمها ونحميها.',
    lastUpdated: 'آخر تحديث',
    effectiveDate: 'تاريخ السريان',
    meta: {
      lastUpdatedValue: '6 فبراير 2026',
      effectiveDateValue: '6 فبراير 2026',
    },
    introduction: 'تؤكد شركة فوجيان جينغهو للتكنولوجيا البيئية ("نحن" أو "لنا") التزامها بحماية خصوصيتك. تشرح سياسة الخصوصية هذه كيفية جمع معلوماتك واستخدامها والإفصاح عنها وحمايتها عند زيارة موقعنا الإلكتروني واستخدام خدماتنا.',
    sections: {
      infoCollect: {
        title: '1. المعلومات التي نجمعها',
        description: 'قد نجمع معلومات شخصية تقدمها لنا طوعًا عندما تقوم بـ:',
        items: [
          'التسجيل على موقعنا الإلكتروني أو تقديم استفسار',
          'طلب عرض أسعار أو معلومات عن منتج',
          'الاشتراك في نشرتنا الإخبارية',
          'التواصل مع فريق المبيعات أو الدعم',
          'المشاركة في الاستطلاعات أو العروض الترويجية',
        ],
      },
      typesCollected: {
        title: '2. أنواع المعلومات المجمعة',
        items: [
          'معلومات التعريف الشخصية: الاسم، البريد الإلكتروني، رقم الهاتف، اسم الشركة، المسمى الوظيفي',
          'المعلومات السكانية: الدولة، المنطقة، تفضيلات اللغة',
          'المعلومات التقنية: عنوان بروتوكول الإنترنت، نوع المتصفح، نظام التشغيل، عناوين الإحالة',
          'بيانات الاتصال: الرسائل والاستفسارات والملاحظات وطلبات الدعم',
        ],
      },
      howUse: {
        title: '3. كيف نستخدم معلوماتك',
        description: 'نستخدم المعلومات التي نجمعها من أجل:',
        items: [
          'توفير منتجاتنا وخدماتنا وصيانتها وتحسينها',
          'الرد على استفساراتك وتقديم دعم العملاء',
          'إرسال معلومات المنتج والعروض الترويجية لك',
          'معالجة المعاملات وإرسال المعلومات ذات الصلة',
          'مراقبة وتحليل الاتجاهات والاستخدام والأنشطة',
          'الكشف عن الاحتيال والتحقيق فيه ومنعه',
          'الامتثال للالتزامات القانونية',
        ],
      },
      dataSecurity: {
        title: '4. أمان البيانات',
        description: 'نطبق تدابير أمنية تقنية وتنظيمية مناسبة لحماية معلوماتك الشخصية من الوصول غير المصرح به والتغيير والإفصاح أو التدمير. ومع ذلك، لا توجد طريقة نقل عبر الإنترنت أو تخزين إلكتروني آمنة بنسبة 100٪.',
        encryption: 'نستخدم تشفير معياري الصناعة (SSL/TLS) لحماية البيانات المنقولة بين متصفحك وخوادمنا.',
      },
      cookies: {
        title: '5. ملفات تعريف الارتباط وتقنيات التتبع',
        description: 'قد يستخدم موقعنا ملفات تعريف الارتباط ورموز الويب وتقنيات التتبع المشابهة لجمع المعلومات حول أنشطة التصفح لديك. يمكنك ضبط متصفحك لرفض جميع ملفات تعريف الارتباط أو الإشارة إلى إرسال ملف تعريف ارتباط.',
      },
      thirdParty: {
        title: '6. الإفصاح للأطراف الثالثة',
        description: 'نحن لا نبيع أو نتداول أو ننقل معلوماتك الشخصية التعريفية للأطراف الخارجية إلا في الظروف التالية:',
        items: [
          'مع مزودي الخدمة الذين يساعدون في عملياتنا التجارية',
          'عندما يقتضي القانون أو أمر المحكمة أو أي إجراء قانوني آخر',
          'لحماية حقوقنا أو خصوصيتك أو سلامتك أو ممتلكاتك',
          'في связи باندماج أو استحواذ أو بيع أصول',
        ],
      },
      dataRetention: {
        title: '7. الاحتفاظ بالبيانات',
        description: 'سنحتفظ بمعلوماتك الشخصية طالما كان ذلك ضروريًا لتحقيق الأغراض outlined في سياسة الخصوصية هذه، ما لم يتطلب القانون فترة احتفاظ أطول.',
      },
      yourRights: {
        title: '8. حقوقك',
        description: 'لديك الحق في:',
        items: [
          'الوصول إلى نسخة من بياناتك الشخصية وتلقيها',
          'تصحيح البيانات الشخصية غير الدقيقة',
          'طلب حذف بياناتك الشخصية',
          'الاعتراض على معالجة بياناتك الشخصية',
          'طلب تقييد المعالجة',
          'قابلية نقل البيانات',
        ],
      },
      children: {
        title: '9. خصوصية الأطفال',
        description: 'موقعنا الإلكتروني غير مخصص للأطفال دون سن 16 عامًا. نحن لا نجمع عن قصد معلومات شخصية من الأطفال دون سن 16 عامًا.',
      },
      international: {
        title: '10. نقل البيانات الدولية',
        description: 'قد يتم نقل معلوماتك ومعالجتها في دول أخرى غير بلد إقامتك. قد يكون لهذه الدول قوانين حماية بيانات تختلف عن قوانين بلدك.',
      },
      changes: {
        title: '11. التغييرات على هذه السياسة',
        description: 'قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنعلمك بأي تغييرات عن طريق نشر سياسة الخصوصية الجديدة على هذه الصفحة وتحديث تاريخ "آخر تحديث" في أعلى هذه السياسة.',
      },
      contactUs: {
        title: '12. اتصل بنا',
        description: 'إذا كانت لديك أسئلة حول سياسة الخصوصية هذه أو ممارسات البيانات لدينا، يرجى الاتصال بنا:',
        email: 'البريد الإلكتروني',
        address: 'عنوان',
        company: 'شركة فوجيان جينغهو للتكنولوجيا البيئية المحدودة',
        addressLine: 'المبنى 25، حديقة وانيانغ للعلوم والتكنولوجيا، طريق تينغ وانغ رقم 26، بلدة تينغ جيانغ، مقاطعة ماوي، فوتشو، مقاطعة فوجيان، الصين',
      },
    },
  },
  terms: {
    title: 'شروط الخدمة',
    subtitle: 'يرجى قراءة هذه الشروط بعناية قبل استخدام موقعنا الإلكتروني وخدماتنا.',
    lastUpdated: 'آخر تحديث',
    effectiveDate: 'تاريخ السريان',
    meta: {
      lastUpdatedValue: '6 فبراير 2026',
      effectiveDateValue: '6 فبراير 2026',
    },
    introduction: 'مرحبًا بكم في موقع شركة فوجيان جينغهو للتكنولوجيا البيئية. باستخدام هذا الموقع، فإنك توافق على الالتزام بشروط الخدمة هذه وجميع القوانين واللوائح المعمول بها. إذا كنت لا توافق على أي جزء من هذه الشروط، فقد لا تستخدم موقعنا.',
    importantNotice: {
      title: 'إشعار مهم',
      description: 'باستخدام هذا الموقع، فإنك تقر بأنك قد قرأت وفهمت ووافقت على الالتزام بشروط الخدمة هذه. إذا كنت تستخدم هذا الموقع نيابة عن شركة أو منظمة، فأنت تمثل أن لديك سلطة ربط هذه الكيان بهذه الشروط.',
    },
    sections: {
      useWebsite: {
        title: '1. استخدام الموقع',
        description: 'يتم توفير هذا الموقع من قبل شركة فوجيان جينغهو للتكنولوجيا البيئية لأغراض إعلامية فقط. باستخدام هذا الموقع، فإنك توافق على:',
        items: [
          'استخدام الموقع لأغراض قانونية فقط وبما يتوافق مع هذه الشروط',
          'عدم استخدام الموقع بأي طريقة قد تؤدي إلى تلفه أو تعطيله أو إرهاقه',
          'عدم محاولة الوصول غير المصرح به إلى أي جزء من الموقع',
          'عدم استخدام الموقع لنقل أي فيروسات أو ديدان أو أكواد ضارة',
          'احترام حقوق الملكية الفكرية لشركة JH Heatsup والآخرين',
        ],
      },
      intellectualProperty: {
        title: '2. حقوق الملكية الفكرية',
        description: 'جميع المحتويات على هذا الموقع هي ملك لشركة فوجيان جينغهو للتكنولوجيا البيئية أو موردي المحتوى الخاص بها.',
        restriction: 'لا يجوز لك إعادة إنتاج أو توزيع أو تعديل أو إنشاء أعمال مشتقة من أو عرض أو أداء أو استغلال أي محتوى من هذا الموقع دون موافقتنا الكتابية المسبقة.',
      },
      productInfo: {
        title: '3. معلومات المنتج والتسعير',
        description: 'جميع المنتجات والخدمات المعروضة على هذا الموقع تخضع للتوفر.',
        pricing: 'السعر والمواصفات قابلة للتغيير دون إشعار.',
        currency: 'يتم عرض جميع الأسعار بالدولار الأمريكي ما لم يُنص على خلاف ذلك.',
      },
      quotesOrders: {
        title: '4. عروض الأسعار والطلبات',
        description: 'العروض المقدمة من خلال هذا الموقع صالحة لمدة 30 يومًا.',
        contract: 'بتقديم طلب، فإنك توافق على شراء المنتجات وفقًا للشروط السارية في ذلك الوقت.',
      },
      warranties: {
        title: '5. الضمانات وإخلاء المسؤولية',
        description: 'هذا الموقع وجميع المحتويات والمنتجات والخدمات المقدمة من خلاله مقدمة "كما هي".',
        disclaimer: 'تُخلي JH Heatsup مسؤوليتها عن جميع الضمانات الصريحة أو الضمنية.',
      },
      liability: {
        title: '6. تحديد المسؤولية',
        description: 'في أي حال من الأحوال، لن تكون شركة فوجيان جينغهو للتكنولوجيا البيئية مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية.',
        limit: 'إجمالي مسؤوليتنا عن أي مطالبة لن يتجاوز المبلغ الذي دفعته.',
      },
      privacy: {
        title: '7. سياسة الخصوصية',
        description: 'استخدامك لهذا الموقع يحكمه أيضًا سياسة الخصوصية الخاصة بنا.',
      },
      thirdPartyLinks: {
        title: '8. روابط الأطراف الثالثة',
        description: 'قد يحتوي هذا الموقع على روابط لمواقع إلكترونية لأطراف ثالثة.',
        recommendation: 'نشجعك على مراجعة شروط وأحكام أي موقع إلكتروني لطرف ثالث تزوره.',
      },
      governingLaw: {
        title: '9. القانون الحاكم والخلافات',
        description: 'تحكم هذه الشروط وتُفسر وفقًا لقوانين جمهورية الصين الشعبية.',
        disputes: 'أي نزاع يجب أن يتم حله من خلال المفاوضات بحسن نية بين الأطراف.',
      },
      export: {
        title: '10. ضوابط التصدير',
        description: 'توافق على الامتثال لجميع قوانين وأنظمة ضوابط التصدير المعمول بها.',
      },
      termination: {
        title: '11. الإنهاء',
        description: 'قد ن إنهاء أو تعليق وصولك إلى هذا الموقع فورًا، دون إشعار مسبق أو مسؤولية.',
      },
      changes: {
        title: '12. التغييرات على هذه الشروط',
        description: 'نحتفظ بالحق في تعديل أو استبدال هذه الشروط في أي وقت.',
      },
      severability: {
        title: '13. قابلية الفصل',
        description: 'إذا تبين أن أي حكم من هذه الشروط غير صالح أو غير قانوني أو غير قابل للتنفيذ، يجب تعديل هذا الحكم.',
      },
      contactUs: {
        title: '14. معلومات الاتصال',
        description: 'إذا كان لديك أي أسئلة حول شروط الخدمة هذه، يرجى الاتصال بنا:',
        email: 'البريد الإلكتروني',
        address: 'العنوان',
        company: 'شركة فوجيان جينغهو للتكنولوجيا البيئية المحدودة',
        addressLine: 'المبنى 25، حديقة وانيانغ للعلوم والتكنولوجيا، طريق تينغ وانغ رقم 26، بلدة تينغ جيانغ، مقاطعة ماوي، فوتشو، مقاطعة فوجيان، الصين',
      },
    },
  },
  installationGuide: {
    header: {
      title: 'دليل التركيب',
      subtitle: 'اتبع هذه الخطوات لتركيب مسخن JH Heatsup بشكل آمن وفعال.',
    },
    safety: {
      title: 'السلامة أولاً',
      description:
        'يجب أن يتم التركيب بواسطة كهربائي مؤهل وفقاً للكهربائية المحلية. تأكد دائماً من إيقاف تيار الكهرباء من اللوحة الرئيسية قبل بدء التركيب.',
    },
    toolsTitle: 'الأدوات المطلوبة',
    tools: {
      electricDrill: 'مثقاب كهربائي',
      screwdriver: 'مفك براغي',
      level: 'ميزان ماء',
      measuringTape: 'شريط قياس',
      wireStrippers: 'قواطع الأسلاك',
      ladder: 'سلّم',
    },
    stepsTitle: 'خطوات التركيب',
    steps: {
      step1: {
        title: 'تحديد الموقع والقياس',
        description:
          'اختر موقعاً على السقف أو الجدار المرتفع. للحصول على أفضل أداء، يجب تركيب المسخن على ارتفاع 2.2 إلى 2.5 متر من الأرضية. علّق نقاط الثقب وفقاً لأبعاد حوامل التركيب المتوفرة في العلبة.',
        bullet1: 'حافظ على مسافة لا تقل عن 0.5 متر من الجدران الجانبية.',
        bullet2: 'تأكد من مسافة لا تقل عن 0.2 متر من السقف (في حالة التركيب على الحائط).',
      },
      step2: {
        title: 'تركيب الحوامل',
        description:
          'اثقب الفتحات في المواضع المحددة وأدخل مسامير التوسيع. ثبّت حوامل التركيب بإحكام على السطح. قدّم حوامل التزلج الخلفية للمسخن في الحوامل المثبتة وشد براغي الضبط لضبط الزاوية المطلوبة (0° أو 15° أو 30° أو 45°).',
      },
      step3: {
        title: 'التوصيل الكهربائي',
        description:
          'وصّل كابل الطاقة بتغذية الشبكة الرئيسية. تأكد من التأريض السليم. للوحدات التي تحتوي على ريموت كنترول، تأكد من أن عين الاستقبال مرئية ليعمل عن بعد بشكل فعال.',
        wireLive: 'L — الحي',
        wireLiveColor: 'بني',
        wireNeutral: 'N — المحايد',
        wireNeutralColor: 'أزرق',
        wireEarth: 'E — الأرض',
        wireEarthColor: 'أصفر / أخضر',
      },
      step4: {
        title: 'الاختبار',
        description:
          'شغّل التيار الكهربائي. يجب أن يصل المسخن إلى درجة حرارة التشغيل الكاملة خلال 5 دقائق. قد تلاحظ رائحة خفيفة أثناء الاستخدام الأول؛ وهذا أمر طبيعي وسوف تزول بسرعة.',
      },
    },
    download: {
      title: 'عرض دليل المنتج',
      subtitle: 'اطلع على دليل التركيب الكامل مع المخططات لطرازك المحدد عبر الإنترنت.',
      jhnr: 'عرض الدليل',
      industrial: 'عرض الدليل',
    },
  },
  warrantyPolicy: {
    header: {
      title: 'سياسة الضمان',
      subtitle: 'التزامنا بالجودة وراحة بالك.',
    },
    overview: {
      standardCoverage: 'التغطية القياسية',
      standardCoverageDesc:
        'تُضمن منتجات JH Heatsup خالية من العيوب في المواد والصناعة تحت الاستخدام العادي.',
      warrantyPeriod: 'فترة الضمان',
      residentialPeriod: 'سنتان للمسخنات السكنية.',
      industrialPeriod: 'سنة واحدة للمسخنات الصناعية والوحدات التحكم.',
    },
    sections: {
      scope: {
        title: '1. نطاق الضمان',
        description:
          'ينطبق هذا الضمان على المشتري الأصلي للمنتج وهو غير قابل للتحويل. يشمل إصلاح أو استبدال أي جزء من المنتج يثبت وجود عيب في المادة أو الصناعة خلال فترة الضمان.',
      },
      notCovered: {
        title: '2. ما لا يغطيه الضمان؟',
        description: 'لا يغطي هذا الضمان الأضرار الناتجة عن:',
        item1: 'تركيب غير صحيح لا يتوافق مع الدليل المقدم.',
        item2: 'سوء الاستخدام أو الإساءة أو الإهمال أو الحوادث.',
        item3: 'تعديل أو تغيير المنتج.',
        item4: 'ارتفاعات التيار الكهربائي أو الصواعق.',
        item5: 'الاستهلاك العادي (مثل تغير لون السطح بمرور الوقت).',
      },
      claim: {
        title: '3. كيفية تقديم مطالبة الضمان',
        description: 'للحصول على خدمة الضمان، يرجى الاتصال بفريق الدعم لدينا مع المعلومات التالية:',
        proofOfPurchase: 'إثبات الشراء (فاتورة/إيصال)',
        defectDescription: 'وصف وصور/فيديو للعيب',
        serialNumber: 'الرقم التسلسلي للوحدة',
        contactEmail: 'البريد الإلكتروني للتواصل',
      },
    },
  },
};
